<div *ngIf="data; else Loading" class="row">
  <div class="col-12 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th
            *ngFor="let headerKey of dynamicColumns; let i = index"
            class="cursor-pointer text-nowrap"
            (click)="sortColumn(dynamicColumns[i])"
          >
            {{ headerKey.translationKey | translate }}
            <i
              *ngIf="headerKey.sort"
              class="fas"
              [ngClass]="{
                'fa-sort-amount-down': headerKey.sort === 'asc',
                'fa-sort-amount-up': headerKey.sort === 'desc'
              }"
            ></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td [attr.data-label]="'WORK_ORDER_ID' | translate"><a [routerLink]="['/work-order-details', item.id]">{{ item.id }}</a></td>
          <td [attr.data-label]="'PARTNER' | translate">{{ item?.extra._gung?.partnerName }}</td>
          <td [attr.data-label]="'CUSTOMER' | translate">{{ item?.extra._gung?.customerName }}</td>
          <td [attr.data-label]="'DATE' | translate">{{ (item.workPerformedDate | date: dateUtilService.dateFormat) || '-' }}</td>
          <td [attr.data-label]="'REG_NR' | translate">{{ item.regNr }}</td>
          <td [attr.data-label]="'TOTAL_PRICE' | translate"><lib-price [price]="item?.extra?._gung?.totalPrice" [currency]="item?.extra?._gung?.currency"></lib-price></td>
          <td [attr.data-label]="'WORK_ORDER_STATE' | translate">{{ item?.workState | translate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #Loading>
  <div class="d-flex justify-content-center w-100 mb-4">
    <i class="fa fa-spinner fa-spin fa-5x"></i>
  </div>
</ng-template>
